export const globalConfig = {
  baseURL: "https://prod.spsdoda.co.kr",
};
